import GoogleMapReact from 'google-map-react';
import React, { useContext } from 'react';
import {SalubrisContext} from './Context';
import Marker from './Marker';

const SearchMap = React.memo(() => {

    const {centers} = useContext(SalubrisContext);
    const centerMarkers = centers.map((center, index) => <Marker key={index} lat={center.lat} lng={center.lng} text={center.name[0]} friendly_url={center.friendly_url} />);

    // Return map bounds based on list of places
    const getMapBounds = (map, maps, centers) => {
        const bounds = new maps.LatLngBounds();

        centers.map((center) => 
            bounds.extend(new maps.LatLng(
                center.lat,
                center.lng,
            ))
        );

        return bounds;
    };

    // Re-center map when resizing the window
    const bindResizeListener = (map, maps, bounds) => {
    maps.event.addDomListenerOnce(map, 'idle', () => {
        maps.event.addDomListener(window, 'resize', () => {
        map.fitBounds(bounds);
        });
    });
    };

    // Fit map to its bounds after the api is loaded
    const apiIsLoaded = (map, maps, centers) => {
        // Get bounds by our places
        const bounds = getMapBounds(map, maps, centers);
        // Fit map to bounds
        map.fitBounds(bounds);
        // Bind the resize listener
        bindResizeListener(map, maps, bounds);
    };

    const mapOtions = {
        minZoom: 8,
        maxZoom: 13,
    }

    return (
        <div style={{ height: '400px', width: '100%' }}>
        <GoogleMapReact
            bootstrapURLKeys={{ key: "AIzaSyC96mjiOZBVVamIiyLtO72fvJZdFjRF-Qg" }}
            defaultCenter={{lat:26.02, lng:-80.337157}}
            defaultZoom={12}
            options={mapOtions}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps, centers)}
            >
                {centerMarkers}
        </GoogleMapReact>
      </div>);
});

export default SearchMap;